import { render, staticRenderFns } from "./InformationElectricModal.vue?vue&type=template&id=ca05c872"
import script from "./InformationElectricModal.vue?vue&type=script&lang=js"
export * from "./InformationElectricModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports